
import React, { useEffect, useState } from "react";
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';

const MicroModuleStats = () => {
  const [modules, setModules] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalModules, setTotalModules] = useState();
  const [activeModule, setActiveModule] = useState();
  const orgInfo = JSON.parse(localStorage.getItem("orgInfo"));

  useEffect(() => {
    fetchMicroModuleStates();
  }, []);

  const fetchMicroModuleStates = () => {
    if (!orgInfo?.org_id) return;
    setLoader(true);
    const token = apiService.getAuthToken();
    apiService
      .get(`fetch-ic-user-micro-course-stats/${orgInfo?.org_id}`, token)
      .then(
        (response) => {
          setModules(response?.data.microCourseList);
          setTotalModules(response?.data?.totalMicroModule);
          if (response?.data.microCourseList.filter(mod => mod?.progress !== "0/0 completed").length > 0) {
            setActiveModule(response?.data.microCourseList.filter(mod => mod?.progress !== "0/0 completed").length || 0);
          }
          setLoader(false);
        },
        (error) => {
          console.error("Error fetching data", error);
          setLoader(false);
        }
      );
  };

  const colors = ["primary", "success", "warning", "danger"];

  return (
    <div className='page__main'>
      <div className="dashboard jetadmin">
        <div className="container-fluid p-0">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h5 className="fw-bold">View Stats &gt; Micro-Modules</h5>
              <p className="text-muted">
                Access detailed performance insights across teams, locations, and demographics to track progress and impact.
              </p>
            </div>

            {/* <div className="ms-auto">
              <button className="btn btn-secondary bg-white">Download Module Wise Data</button>
            </div> */}
          </div>

          <div className="d-flex p-3 border-radius-20 bg-white shadow-sm gap-3 mb-4">
            <div className="text-white rounded-3 px-4 py-2" style={{ backgroundColor: '#23A298' }}>
              <div className="fw-bold fs-4">{totalModules || 0}</div>
              <div>Total Modules</div>
            </div>
            <div className="text-white rounded-3 px-4 py-2" style={{ backgroundColor: '#F49390' }}>
              <div className="fw-bold fs-4">{activeModule || 0}</div>
              <div>Active Module</div>
            </div>
          </div>

          <div className="row">
            {loader ? <Loader /> : (
              modules?.map((mod, i) => {
                return (
                  <div className="col-md-6 mb-4" key={i}>
                    <div className="card p-4 border-radius-20 bg-white shadow-sm">

                      <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <h3 className="font-20 fw-bold mb-0">{mod.name}</h3>
                        <p className="mb-0">
                          {mod?.start_date !== "" && (
                            <small className="text-muted">
                              <img src="/images/calender-icon.svg" alt="Calendar" width={12} />
                              {new Date(mod.start_date).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                            </small>
                          )}
                        </p>
                      </div>

                      <hr />

                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="fw-bold mb-2">Progress</div>
                        <div className="mb-2 fw-bold text-muted">{mod.progress}</div>
                      </div>

                      {(() => {
                        const match = mod.progress.match(/^(\d+)\/(\d+)/); // Match "3/3"
                        if (!match) return null;

                        const completed = parseInt(match[1], 10);
                        const total = parseInt(match[2], 10);
                        const percentage = Math.round((completed / total) * 100);

                        return (
                          <div className="progress mb-4" style={{ height: '8px' }}>
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{ width: `${percentage}%`, ...(percentage < 100 ? { background: 'linear-gradient(90deg, #24A198, #F1756D)' } : { backgroundColor: '#24A198' }) }}
                              aria-valuenow={percentage}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        );
                      })()}


                      <div className="table-responsive">
                        {mod.users?.length === 0 || mod.progress === "0/0 completed" ? (
                          <div className="text-center text-muted py-3">
                            No members have started this module yet.
                          </div>
                        ) : (
                          <table className="table table-sm align-middle">
                            <thead className="table-light">
                              <tr>
                                <th>Full Name</th>
                                <th>Role</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {mod.users?.map((user, idx) => (
                                <tr key={idx}>
                                  <td>{user.fullName}</td>
                                  <td>{user.role || '-'}</td>
                                  <td>{user.status === 'inprogress' ? <span style={{ color: '#F3B532' }}><img src="/images/pending.svg" alt="Pending" width={12} /> pending</span> : <span style={{ color: '#23A298' }}><img src="/images/completed-check.svg" alt="Completed" width={12} /> {user.status}</span>}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }))}

          </div>
        </div>
      </div>
    </div>

  );
};

export default MicroModuleStats;
